export default __webpack_public_path__ + "static/media/SGI-Europa.1285f6b0.jpg";